import React from 'react';
import { Power, PowerOff, Copy, Trash2, Check } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { SharedLink } from '@/types';

interface LinkActionsProps {
  link: SharedLink;
  isAdmin: boolean;
  onToggleStatus: () => void;
  onDelete: () => void;
  onCopy: () => void;
  copiedLinkId: string | null;
}

export function LinkActions({ 
  link, 
  isAdmin, 
  onToggleStatus, 
  onDelete, 
  onCopy,
  copiedLinkId 
}: LinkActionsProps) {
  return (
    <div className="flex gap-2">
      <Button
        variant={copiedLinkId === link.id ? "secondary" : "outline"}
        onClick={onCopy}
        disabled={!link.isActive}
        className="flex-1 sm:flex-none hover:bg-secondary"
      >
        {copiedLinkId === link.id ? (
          <>
            <Check className="h-4 w-4 ml-2" />
            تم النسخ!
          </>
        ) : (
          <>
            <Copy className="h-4 w-4 ml-2" />
            نسخ
          </>
        )}
      </Button>
      {isAdmin && (
        <>
          <Button
            variant="ghost"
            size="icon"
            onClick={onToggleStatus}
            className={link.isActive ? 'text-red-600' : 'text-green-600'}
            title={link.isActive ? 'إلغاء تنشيط الرابط' : 'تنشيط الرابط'}
          >
            {link.isActive ? (
              <PowerOff className="h-5 w-5" />
            ) : (
              <Power className="h-5 w-5" />
            )}
          </Button>
          <Button
            variant="ghost"
            size="icon"
            onClick={onDelete}
            className="text-red-600 hover:text-red-700 hover:bg-red-50"
            title="حذف الرابط"
          >
            <Trash2 className="h-5 w-5" />
          </Button>
        </>
      )}
    </div>
  );
}